import $ from 'jquery';
import videojs from 'video.js';
import AnnotationComments from '@pixwel/videojs-annotation-comments';

// expose jQuery as globals expected by the plugin
if(typeof window !== 'undefined') {
	window.$ = window.jQuery = $;
}

export default function setupVideoJs() {
	try {
		videojs.registerPlugin('annotationComments', AnnotationComments(videojs));
	}
	catch(e) {
		throw new Error(e.message);
	}
}
